import React from "react";
import {connect} from "react-redux";
import {
  TextInput,
  Create,
  SimpleForm,
  translate
} from "admin-on-rest";
import {Card, CardHeader, CardActions} from "material-ui/Card";
import formStyle from "./style";

const RegionActions = ({
  resource,
  filters,
  displayedFilters,
  filterValues,
  basePath,
  showFilter
}) => (
  <CardActions style={formStyle.cardActionStyle}>
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button"
      })}
  </CardActions>
);

const RegionTitleBase = ({record, translate}) => {
  return (
    <span style={formStyle.titleStyle}>
      {translate("resources.regions.name")}
    </span>
  );
};

const RegionTitle = translate(RegionTitleBase);

class RegionCreateFormBase extends React.Component {
  
  render() {
    const props = {...this.props};
    return (
      <div>
        <Card style={formStyle.titleContainer}>
          <CardHeader title={<RegionTitle />} />
        </Card>

        <Create title=" " actions={<RegionActions />} {...props}>
          <SimpleForm>
            <TextInput
              label="resources.regions.inputs.name"
              source="name"
            />
          </SimpleForm>
        </Create>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    configuration: state.configuration
  };
};

const RegionCreateForm = connect(mapStateToProps)(
  translate(RegionCreateFormBase)
);

export default RegionCreateForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/Regions/RegionCreateForm.js